(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.item = this.querySelector('[data-item]');
      this.check();
      this.onResize = () => this.check();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    check() {
      if (!this.item) return;
      var isMobile = window.innerWidth < 750;
      var overflowing = this.item.scrollWidth > this.clientWidth - 40;
      this.classList.toggle('is-marquee', isMobile && overflowing);
    }
  }

  customElements.define('announcement-marquee', AnnouncementMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafe-grid"] && !Shopify.designMode) return;
  try {
    
  class CafeCatalog extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-cafe-grid]');
      if (!this.grid) return;

      this.cards = Array.from(this.grid.children);
      this.countEl = this.querySelector('[data-cafe-count]');
      this.emptyEl = this.querySelector('[data-cafe-empty]');
      this.sortSelect = this.querySelector('[data-cafe-sort]');
      this.filterGroups = Array.from(this.querySelectorAll('[data-filter-group]'));

      this.state = { formato: 'all', mezcla: 'all' };

      var params = new URLSearchParams(window.location.search);
      var formatoParam = params.get('formato');

      this.filterGroups.forEach((group) => {
        var key = group.getAttribute('data-filter-group');
        var pills = Array.from(group.querySelectorAll('[data-filter-value]'));

        if (key === 'formato' && formatoParam) {
          var match = pills.some(function (pill) {
            return pill.getAttribute('data-filter-value') === formatoParam;
          });
          if (match) this.state.formato = formatoParam;
        }

        pills.forEach((pill) => {
          if (pill.getAttribute('data-filter-value') === this.state[key]) {
            pill.classList.add('is-active');
          }
          pill.addEventListener('click', () => {
            pills.forEach(function (p) { p.classList.remove('is-active'); });
            pill.classList.add('is-active');
            this.state[key] = pill.getAttribute('data-filter-value');
            this.apply();
          });
        });
      });

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.apply());
      }

      this.apply();
    }

    apply() {
      var state = this.state;
      var visibleCount = 0;

      this.cards.forEach(function (card) {
        var matchesFormato = state.formato === 'all' || card.getAttribute('data-formato') === state.formato;
        var matchesMezcla = state.mezcla === 'all' || card.getAttribute('data-blend') === state.mezcla;
        var visible = matchesFormato && matchesMezcla;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.sortSelect) {
        var sortValue = this.sortSelect.value;
        var grid = this.grid;
        var ordered = this.cards.slice();

        if (sortValue !== 'featured') {
          ordered.sort(function (a, b) {
            if (sortValue === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
            if (sortValue === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
            if (sortValue === 'name-asc') return a.dataset.title.localeCompare(b.dataset.title);
            if (sortValue === 'name-desc') return b.dataset.title.localeCompare(a.dataset.title);
            return 0;
          });
        }

        ordered.forEach(function (card) { grid.appendChild(card); });
      }

      if (this.countEl) {
        this.countEl.textContent = visibleCount + (visibleCount === 1 ? ' producto' : ' productos');
      }
      if (this.emptyEl) {
        this.emptyEl.hidden = visibleCount === 0 ? false : true;
      }
    }
  }

  customElements.define('cafe-catalog', CafeCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.documentElement.classList.remove('nav-open');
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.header__overlay-panel a')) {
      document.documentElement.classList.remove('nav-open');
    }
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var group = toggle.closest('[data-menu-group]');
    var submenu = group ? group.querySelector('[data-submenu]') : null;
    if (!submenu) return;
    var isExpanded = !submenu.hidden;
    submenu.hidden = isExpanded;
    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
  });

  (function () {
    var root = document.documentElement;
    var header = document.querySelector('.header');
    var bar = document.querySelector('.announcement-bar');
    var sentinel = document.querySelector('.header__sentinel');

    function updateChromeHeight() {
      var headerHeight = header ? header.offsetHeight : 0;
      var barHeight = bar && !root.classList.contains('header-pinned') ? bar.offsetHeight : 0;
      root.style.setProperty('--header-height', headerHeight + 'px');
      root.style.setProperty('--chrome-height', headerHeight + barHeight + 'px');
    }

    updateChromeHeight();

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(updateChromeHeight);
      if (header) resizeObserver.observe(header);
      if (bar) resizeObserver.observe(bar);
    } else {
      window.addEventListener('resize', updateChromeHeight);
    }

    if (sentinel) {
      var ticking = false;

      function checkPin() {
        ticking = false;
        var pinned = sentinel.getBoundingClientRect().top < 0;
        if (pinned !== root.classList.contains('header-pinned')) {
          root.classList.toggle('header-pinned', pinned);
          updateChromeHeight();
        }
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(checkPin);
        }
      }

      checkPin();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();

  function formatPrice(cents, currency) {
    var code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
    var whole = Math.floor(cents / 100);
    var frac = Math.round(cents - whole * 100);
    var withCommas = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + withCommas + (frac > 0 ? '.' + String(frac).padStart(2, '0') : '') + ' ' + code;
  }
  window.formatPrice = window.formatPrice || formatPrice;

  // Selector de país/moneda: cerrar al hacer clic fuera o con Escape.
  (function () {
    var selector = document.querySelector('[data-locale-selector]');
    if (!selector) return;
    document.addEventListener('click', function (event) {
      if (selector.open && !selector.contains(event.target)) selector.removeAttribute('open');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && selector.open) selector.removeAttribute('open');
    });
  })();

  function cartImageUrl(url, width) {
    if (!url) return url;
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'width=' + width;
  }

  var cartVariantImages = null;
  function cartItemImageUrl(item, width) {
    if (cartVariantImages === null) {
      cartVariantImages = {};
      var el = document.querySelector('[data-cart-variant-images]');
      if (el) {
        try {
          cartVariantImages = JSON.parse(el.textContent) || {};
        } catch (e) {
          cartVariantImages = {};
        }
      }
    }
    var galleryUrl = cartVariantImages[String(item.variant_id)];
    return galleryUrl || cartImageUrl(item.image, width);
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-cart-drawer-overlay]');
      this.closeButton = this.querySelector('[data-cart-drawer-close]');
      this.body = this.querySelector('[data-cart-drawer-body]');
      this.footer = this.querySelector('[data-cart-drawer-footer]');
      this.subtotalEl = this.querySelector('[data-cart-drawer-subtotal]');
      this.emptyMessage = this.body ? this.body.innerHTML : '';
      this.badges = Array.from(document.querySelectorAll('[data-cart-drawer-count]'));

      var toggles = Array.from(document.querySelectorAll('[data-cart-drawer-toggle]'));
      toggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      if (this.body) {
        this.body.addEventListener('click', (event) => {
          var removeButton = event.target.closest('[data-cart-drawer-remove]');
          if (removeButton) {
            this.changeLine(removeButton.closest('[data-cart-drawer-item]').getAttribute('data-line-key'), 0);
            return;
          }
          var decreaseButton = event.target.closest('[data-cart-drawer-qty-decrease]');
          if (decreaseButton) {
            var itemDec = decreaseButton.closest('[data-cart-drawer-item]');
            var inputDec = itemDec.querySelector('[data-cart-drawer-qty-input]');
            var nextDec = Math.max(0, parseInt(inputDec.value, 10) - 1);
            this.changeLine(itemDec.getAttribute('data-line-key'), nextDec);
            return;
          }
          var increaseButton = event.target.closest('[data-cart-drawer-qty-increase]');
          if (increaseButton) {
            var itemInc = increaseButton.closest('[data-cart-drawer-item]');
            var inputInc = itemInc.querySelector('[data-cart-drawer-qty-input]');
            var nextInc = (parseInt(inputInc.value, 10) || 0) + 1;
            this.changeLine(itemInc.getAttribute('data-line-key'), nextInc);
          }
        });
      }

      document.addEventListener('submit', (event) => {
        var form = event.target.closest('form[data-cart-add-form]');
        if (!form) return;
        event.preventDefault();
        this.addFromForm(form);
      });

      this.refresh();
    }

    open() {
      document.documentElement.classList.remove('nav-open');
      var menuToggle = document.querySelector('.header__menu-toggle');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');

      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        document.documentElement.classList.add('cart-open');
      });
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('cart-open');
      setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 300);
    }

    addFromForm(form) {
      var submitButton = form.querySelector('[data-add-to-cart]');
      var originalLabel = submitButton ? submitButton.textContent : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Agregando…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
        .then((result) => {
          if (!result.ok) {
            throw new Error((result.data && result.data.description) || 'No se pudo agregar el producto.');
          }
          return this.refresh();
        })
        .then(() => {
          this.open();
        })
        .catch((error) => {
          window.alert(error.message || 'No se pudo agregar el producto al carrito.');
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalLabel;
          }
        });
    }

    changeLine(lineKey, quantity) {
      var item = this.body.querySelector('[data-line-key="' + lineKey + '"]');
      if (item) item.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      })
        .then((response) => response.json())
        .then(() => this.refresh())
        .catch(() => {
          window.alert('No se pudo actualizar el carrito.');
          if (item) item.classList.remove('is-updating');
        });
    }

    refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => this.render(cart));
    }

    render(cart) {
      this.badges.forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });

      if (!this.body) return;

      if (cart.item_count === 0) {
        this.body.innerHTML = this.emptyMessage;
        if (this.footer) this.footer.hidden = true;
        return;
      }

      var html = cart.items
        .map((item) => {
          var imageUrl = cartItemImageUrl(item, 200);
          var variantLine =
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
              : '';
          return (
            '<div class="cart-drawer__item" data-cart-drawer-item data-line-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-drawer__item-image-link">' +
            (imageUrl
              ? '<img src="' + imageUrl + '" alt="' + item.product_title + '" class="cart-drawer__item-image" loading="lazy">'
              : '') +
            '</a>' +
            '<div class="cart-drawer__item-body">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title-link">' +
            '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
            '</a>' +
            variantLine +
            '<div class="cart-drawer__item-footer">' +
            '<div class="cart-drawer__item-stepper">' +
            '<button type="button" data-cart-drawer-qty-decrease aria-label="Reducir cantidad">−</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" data-cart-drawer-qty-input readonly>' +
            '<button type="button" data-cart-drawer-qty-increase aria-label="Aumentar cantidad">+</button>' +
            '</div>' +
            cartItemPriceHtml(item, cart.currency) +
            '</div>' +
            cartItemDiscountHtml(item, cart.currency) +
            '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove>Eliminar</button>' +
            '</div>' +
            '</div>'
          );
        })
        .join('');

      this.body.innerHTML = html;

      if (this.footer) {
        this.footer.hidden = false;
      }
      if (this.subtotalEl) {
        this.subtotalEl.textContent = formatPrice(cart.total_price, cart.currency);
      }
      if (window.updateFreeShippingBars) window.updateFreeShippingBars(cart.total_price);
      if (window.updateCartUpsell) window.updateCartUpsell(cart);
    }
  }

  // Precio de línea: tachado + rebajado cuando hay un descuento (código o automático) sobre la línea.
  function cartItemPriceHtml(item, currency) {
    var original = item.original_line_price;
    var final = item.final_line_price != null ? item.final_line_price : item.line_price;
    if (original != null && final < original) {
      return (
        '<span class="cart-drawer__item-price cart-drawer__item-price--discounted">' +
        '<s class="cart-drawer__item-price-original">' + formatPrice(original, currency) + '</s> ' +
        '<span>' + formatPrice(final, currency) + '</span>' +
        '</span>'
      );
    }
    return '<span class="cart-drawer__item-price">' + formatPrice(final, currency) + '</span>';
  }

  function cartItemDiscountHtml(item, currency) {
    var allocations = item.line_level_discount_allocations || [];
    if (!allocations.length) return '';
    return allocations
      .map(function (allocation) {
        var title = (allocation.discount_application && allocation.discount_application.title) || 'Descuento';
        return (
          '<p class="cart-drawer__item-discount">' +
          title + ' (−' + formatPrice(allocation.amount, currency) + ')' +
          '</p>'
        );
      })
      .join('');
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.current = 0;

      this.slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (index === this.current) {
          this.playVideo(video);
        } else {
          video.pause();
        }
      });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      if (this.slides.length > 1) {
        this.restartTimer();
      }
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    /* Solo reproduce si el video tiene fuente: en móvil no la tiene y llamar a play()
       hace que Safari oculte el poster (queda la <img> de fondo). */
    playVideo(video) {
      if (!video.currentSrc && !video.src && !video.querySelector('source')) return;
      video.play().catch(function () {});
    }

    restartTimer() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.goTo((this.current + 1) % this.slides.length);
      }, 4000);
    }

    goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current]?.classList.remove('is-active');
      this.slides[this.current].querySelector('video')?.pause();

      this.current = index;
      this.slides[this.current].classList.add('is-active');
      this.dots[this.current]?.classList.add('is-active');

      var nextVideo = this.slides[this.current].querySelector('video');
      if (nextVideo) {
        nextVideo.currentTime = 0;
        this.playVideo(nextVideo);
      }

      if (this.slides.length > 1) {
        this.restartTimer();
      }
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-grid"] && !Shopify.designMode) return;
  try {
    
  class MerchCatalog extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-merch-grid]');
      if (!this.grid) return;

      this.cards = Array.from(this.grid.children);
      this.countEl = this.querySelector('[data-merch-count]');
      this.sortSelect = this.querySelector('[data-merch-sort]');

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.apply());
      }

      this.apply();
    }

    apply() {
      if (this.countEl) {
        var count = this.cards.length;
        this.countEl.textContent = count + (count === 1 ? ' producto' : ' productos');
      }

      if (this.sortSelect) {
        var sortValue = this.sortSelect.value;
        var grid = this.grid;
        var ordered = this.cards.slice();

        if (sortValue !== 'featured') {
          ordered.sort(function (a, b) {
            if (sortValue === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
            if (sortValue === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
            if (sortValue === 'name-asc') return a.dataset.title.localeCompare(b.dataset.title);
            if (sortValue === 'name-desc') return b.dataset.title.localeCompare(a.dataset.title);
            return 0;
          });
        }

        ordered.forEach(function (card) { grid.appendChild(card); });
      }
    }
  }

  customElements.define('merch-catalog', MerchCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mezclas-grid"] && !Shopify.designMode) return;
  try {
    
  /* Selector Grano / Molido: cambia imagen, título, precio y enlaces de la tarjeta. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-format-button]');
    if (!button) return;
    var card = button.closest('[data-mezclas-card]');
    if (!card || button.classList.contains('is-active')) return;

    card.querySelectorAll('[data-format-button]').forEach(function (b) {
      var active = b === button;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var image = card.querySelector('[data-format-image]');
    if (image && button.dataset.image) {
      image.src = button.dataset.image;
      image.srcset = button.dataset.srcset || '';
      image.alt = button.dataset.title || '';
    }

    var title = card.querySelector('[data-format-title]');
    if (title) title.textContent = button.dataset.title;

    var price = card.querySelector('[data-format-price]');
    if (price && button.dataset.price) price.textContent = button.dataset.price;

    card.querySelectorAll('[data-format-link]').forEach(function (link) {
      link.href = button.dataset.url;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  class PageBannerImages extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));

      if (this.slides.length <= 1) return;

      var restoreDeferred = () => {
        this.querySelectorAll('img[data-src]').forEach(function (img) {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      };
      if (document.readyState === 'complete') restoreDeferred();
      else window.addEventListener('load', restoreDeferred, { once: true });

      this.current = this.slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      if (this.current < 0) this.current = 0;

      this.interval = setInterval(() => {
        this.slides[this.current].classList.remove('is-active');
        this.current = (this.current + 1) % this.slides.length;
        this.slides[this.current].classList.add('is-active');
      }, 4000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('page-banner-images', PageBannerImages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cafe"]) return;
  try {
    
  class ProductCafe extends HTMLElement {
    connectedCallback() {
      var jsonEl = this.querySelector('[data-variant-json]');
      if (!jsonEl) return;
      this.variants = JSON.parse(jsonEl.textContent);

      this.optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
      this.priceEl = this.querySelector('[data-product-price]');
      this.variantIdInput = this.querySelector('[data-variant-id-input]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.buyNow = this.querySelector('[data-buy-now]');
      this.sizeLabel = this.querySelector('[data-size-label]');
      this.galleryMainItems = Array.from(this.querySelectorAll('[data-gallery-main] [data-media-id]'));
      this.thumbsWrap = this.querySelector('[data-gallery-thumbs]');
      this.galleryThumbs = Array.from(this.querySelectorAll('[data-gallery-thumbs] [data-media-id]'));
      this.lightbox = this.querySelector('[data-lightbox]');
      this.lightboxItems = Array.from(this.querySelectorAll('[data-lightbox] [data-media-id]'));
      this.qtyInput = this.querySelector('[data-qty-input]');

      /* Membresía / suscripción */
      this.planRadios = Array.from(this.querySelectorAll('[data-plan-radio]'));
      this.planPriceEls = Array.from(this.querySelectorAll('[data-plan-price]'));
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
      this.selectedPlan = '';

      var firstAvailable = this.variants.find(function (v) { return v.available; }) || this.variants[0] || {};
      this.selected = [firstAvailable.option1, firstAvailable.option2, firstAvailable.option3].filter(function (v) {
        return v !== null && v !== undefined;
      });

      this.optionGroups.forEach((group, index) => {
        var pills = Array.from(group.querySelectorAll('[data-option-value]'));
        pills.forEach((pill) => {
          pill.addEventListener('click', () => {
            if (pill.hidden) return;
            this.selected[index] = pill.getAttribute('data-option-value');
            this.updateAvailability();
            this.syncUI();
            this.updateVariant();
          });
        });
      });

      this.planRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          this.selectedPlan = radio.value;
          this.planRadios.forEach(function (r) {
            var label = r.closest('.product-cafe__plan');
            if (label) label.classList.toggle('is-active', r === radio);
          });
          this.updateVariant();
        });
      });

      /* Lista de espera: modal nativo con el formulario de cliente de Shopify */
      var modal = this.querySelector('[data-waitlist-modal]');
      if (modal) {
        var successBox = modal.querySelector('[data-waitlist-success]');
        var formBox = modal.querySelector('[data-waitlist-form]');
        var openModal = function (success) {
          if (successBox) successBox.hidden = !success;
          if (formBox) formBox.hidden = !!success;
          if (typeof modal.showModal === 'function') {
            if (!modal.open) modal.showModal();
          } else {
            modal.setAttribute('open', '');
          }
          document.documentElement.classList.add('waitlist-open');
          if (!success) {
            var emailInput = modal.querySelector('input[type="email"]');
            if (emailInput) emailInput.focus();
          }
        };
        var closeModal = function () {
          if (typeof modal.close === 'function' && modal.open) modal.close();
          else modal.removeAttribute('open');
          document.documentElement.classList.remove('waitlist-open');
        };
        document.addEventListener('click', function (event) {
          if (event.target.closest('[data-waitlist-open]')) openModal(false);
        });
        modal.querySelectorAll('[data-waitlist-close]').forEach(function (btn) {
          btn.addEventListener('click', closeModal);
        });
        modal.addEventListener('click', function (event) {
          if (event.target === modal) closeModal();
        });
        modal.addEventListener('close', function () {
          document.documentElement.classList.remove('waitlist-open');
        });
        var params = new URLSearchParams(window.location.search);
        if (params.get('lista') === 'ok' || params.get('customer_posted') === 'true' || modal.querySelector('[data-waitlist-posted]')) {
          openModal(true);
          if (window.history && history.replaceState) history.replaceState(null, '', window.location.pathname);
        } else if (modal.querySelector('[data-waitlist-errors]')) {
          openModal(false);
        }
      }

      var decreaseBtn = this.querySelector('[data-qty-decrease]');
      var increaseBtn = this.querySelector('[data-qty-increase]');
      if (decreaseBtn && this.qtyInput) {
        decreaseBtn.addEventListener('click', () => {
          var value = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) - 1);
          this.qtyInput.value = value;
        });
      }
      if (increaseBtn && this.qtyInput) {
        increaseBtn.addEventListener('click', () => {
          var value = (parseInt(this.qtyInput.value, 10) || 1) + 1;
          this.qtyInput.value = value;
        });
      }

      this.galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.setActiveMedia(thumb.getAttribute('data-media-id')));
      });

      var galleryMain = this.querySelector('[data-gallery-main]');
      if (galleryMain && this.lightbox) {
        galleryMain.addEventListener('click', () => {
          this.lightbox.hidden = false;
        });
      }

      if (galleryMain && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        galleryMain.addEventListener('mousemove', (event) => {
          var activeItem = galleryMain.querySelector('.product-cafe__main-item.is-active');
          if (!activeItem) return;
          var layer = activeItem.querySelector('.product-cafe__zoom-layer');
          if (!layer) return;
          if (layer.dataset.zoomSrc && !layer.style.backgroundImage) {
            layer.style.backgroundImage = 'url(' + layer.dataset.zoomSrc + ')';
          }
          var rect = galleryMain.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          layer.style.backgroundPosition = x + '% ' + y + '%';
          activeItem.classList.add('is-zooming');
        });
        galleryMain.addEventListener('mouseleave', () => {
          this.galleryMainItems.forEach(function (item) {
            item.classList.remove('is-zooming');
          });
        });
      }

      var lightboxItemEls = Array.from(this.querySelectorAll('[data-lightbox] .product-cafe__lightbox-item'));
      var resetLightboxZoom = function () {
        lightboxItemEls.forEach(function (i) { i.classList.remove('is-zoomed'); });
      };

      var lightboxClose = this.querySelector('[data-lightbox-close]');
      if (lightboxClose && this.lightbox) {
        lightboxClose.addEventListener('click', () => {
          this.lightbox.hidden = true;
          resetLightboxZoom();
        });
      }
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (event) => {
          if (!event.target.closest('.product-cafe__lightbox-image')) {
            this.lightbox.hidden = true;
            resetLightboxZoom();
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.lightbox.hidden = true;
            resetLightboxZoom();
          }
        });

        var lightboxImages = Array.from(this.querySelectorAll('[data-lightbox] .product-cafe__lightbox-image'));
        lightboxImages.forEach((img) => {
          img.addEventListener('click', (event) => {
            event.stopPropagation();
            var item = img.closest('.product-cafe__lightbox-item');
            var wasZoomed = item.classList.contains('is-zoomed');
            lightboxItemEls.forEach(function (i) { i.classList.remove('is-zoomed'); });
            if (!wasZoomed) {
              var rect = img.getBoundingClientRect();
              var originX = ((event.clientX - rect.left) / rect.width) * 100;
              var originY = ((event.clientY - rect.top) / rect.height) * 100;
              img.style.transformOrigin = originX + '% ' + originY + '%';
              item.classList.add('is-zoomed');
            }
          });
        });
      }

      this.updateAvailability();
      this.syncUI();
      this.updateVariant();
    }

    updateAvailability() {
      var self = this;
      this.optionGroups.forEach(function (group, index) {
        var pills = Array.from(group.querySelectorAll('[data-option-value]'));
        pills.forEach(function (pill) {
          var value = pill.getAttribute('data-option-value');
          var testSelection = self.selected.slice(0, index);
          testSelection[index] = value;
          var matches = self.variants.some(function (v) {
            var variantOpts = [v.option1, v.option2, v.option3];
            return testSelection.every(function (sel, i) { return sel == null || variantOpts[i] === sel; });
          });

          pill.hidden = !matches;
        });

        var currentValue = self.selected[index];
        var currentPill = pills.find(function (p) { return p.getAttribute('data-option-value') === currentValue; });
        if (!currentPill || currentPill.hidden) {
          var firstAvailablePill = pills.find(function (p) { return !p.hidden; });
          if (firstAvailablePill) {
            self.selected[index] = firstAvailablePill.getAttribute('data-option-value');
          }
        }
      });
    }

    syncUI() {
      var self = this;
      this.optionGroups.forEach(function (group, index) {
        var pills = Array.from(group.querySelectorAll('[data-option-value]'));
        pills.forEach(function (pill) {
          pill.classList.toggle('is-active', pill.getAttribute('data-option-value') === self.selected[index]);
        });
      });
    }

    updateVariant() {
      var self = this;
      var match = this.variants.find(function (v) {
        var variantOpts = [v.option1, v.option2, v.option3];
        return self.selected.every(function (sel, i) { return variantOpts[i] === sel; });
      });
      if (!match) return;

      if (this.variantIdInput) this.variantIdInput.value = match.id;
      this.applyPlanPricing(match);
      if (this.sizeLabel && match.option1) this.sizeLabel.textContent = match.option1;
      if (this.addButton) {
        this.addButton.disabled = !match.available;
        this.addButton.textContent = match.available
          ? this.addButton.getAttribute('data-label-available')
          : this.addButton.getAttribute('data-label-sold-out');
      }
      /* "Comprar ahora" es compra única: se oculta con la suscripción elegida o sin stock */
      if (this.buyNow) this.buyNow.hidden = !match.available || !!this.selectedPlan;
      this.filterGalleryForVariant(match.id);
    }

    /* Precio según la opción elegida (compra única o plan de suscripción) */
    applyPlanPricing(match) {
      var allocations = match.allocations || [];
      var findAllocation = function (planId) {
        return allocations.find(function (a) { return String(a.plan_id) === String(planId); });
      };

      this.planPriceEls.forEach(function (el) {
        var planId = el.getAttribute('data-plan-price');
        if (!planId) {
          el.textContent = match.price_formatted;
          return;
        }
        var allocation = findAllocation(planId);
        el.textContent = allocation ? allocation.price_formatted : match.price_formatted;
      });

      var price = match.price_formatted;
      if (this.selectedPlan) {
        var selectedAllocation = findAllocation(this.selectedPlan);
        if (selectedAllocation) price = selectedAllocation.price_formatted;
      }
      if (this.priceEl) this.priceEl.textContent = price;

      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = this.selectedPlan;
        this.sellingPlanInput.disabled = !this.selectedPlan;
      }
    }

    filterGalleryForVariant(variantId) {
      var idStr = String(variantId);

      function variantIdsOf(el) {
        var raw = el.getAttribute('data-variant-ids') || '';
        return raw ? raw.split(',') : [];
      }

      var dedicated = this.galleryMainItems.filter(function (el) {
        return variantIdsOf(el).indexOf(idStr) !== -1;
      });
      var pool = dedicated.length > 0
        ? dedicated
        : this.galleryMainItems.filter(function (el) { return variantIdsOf(el).length === 0; });
      var visibleIds = pool.map(function (el) { return el.getAttribute('data-media-id'); });

      function applyVisibility(elements) {
        var visible = [];
        elements.forEach(function (el) {
          var isVisible = visibleIds.indexOf(el.getAttribute('data-media-id')) !== -1;
          el.hidden = !isVisible;
          if (isVisible) visible.push(el);
        });
        return visible;
      }

      var visibleMain = applyVisibility(this.galleryMainItems);
      applyVisibility(this.galleryThumbs);
      applyVisibility(this.lightboxItems);

      if (this.thumbsWrap) {
        this.thumbsWrap.hidden = visibleMain.length <= 1;
      }

      var stillActive = visibleMain.find(function (el) { return el.classList.contains('is-active'); });
      var nextActive = stillActive || visibleMain[0];
      if (nextActive) this.setActiveMedia(nextActive.getAttribute('data-media-id'));
    }

    setActiveMedia(mediaId) {
      var idString = String(mediaId);
      this.galleryMainItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === idString);
      });
      this.galleryThumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === idString);
      });
      this.lightboxItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === idString);
      });
    }
  }

  customElements.define('product-cafe', ProductCafe);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-merch"]) return;
  try {
    
  class ProductMerch extends HTMLElement {
    connectedCallback() {
      var jsonEl = this.querySelector('[data-variant-json]');
      if (!jsonEl) return;
      this.variants = JSON.parse(jsonEl.textContent);

      this.optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
      this.priceEl = this.querySelector('[data-product-price]');
      this.variantIdInput = this.querySelector('[data-variant-id-input]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.buyNow = this.querySelector('[data-buy-now]');
      this.galleryMainItems = Array.from(this.querySelectorAll('[data-gallery-main] [data-media-id]'));
      this.thumbsWrap = this.querySelector('[data-gallery-thumbs]');
      this.galleryThumbs = Array.from(this.querySelectorAll('[data-gallery-thumbs] [data-media-id]'));
      this.lightbox = this.querySelector('[data-lightbox]');
      this.lightboxItems = Array.from(this.querySelectorAll('[data-lightbox] [data-media-id]'));
      this.qtyInput = this.querySelector('[data-qty-input]');

      var firstAvailable = this.variants.find(function (v) { return v.available; }) || this.variants[0] || {};
      this.selected = [firstAvailable.option1, firstAvailable.option2, firstAvailable.option3].filter(function (v) {
        return v !== null && v !== undefined;
      });

      this.optionGroups.forEach((group, index) => {
        var pills = Array.from(group.querySelectorAll('[data-option-value]'));
        pills.forEach((pill) => {
          pill.addEventListener('click', () => {
            if (pill.hidden) return;
            this.selected[index] = pill.getAttribute('data-option-value');
            this.updateAvailability();
            this.syncUI();
            this.updateVariant();
          });
        });
      });

      var decreaseBtn = this.querySelector('[data-qty-decrease]');
      var increaseBtn = this.querySelector('[data-qty-increase]');
      if (decreaseBtn && this.qtyInput) {
        decreaseBtn.addEventListener('click', () => {
          var value = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) - 1);
          this.qtyInput.value = value;
        });
      }
      if (increaseBtn && this.qtyInput) {
        increaseBtn.addEventListener('click', () => {
          var value = (parseInt(this.qtyInput.value, 10) || 1) + 1;
          this.qtyInput.value = value;
        });
      }

      this.galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.setActiveMedia(thumb.getAttribute('data-media-id')));
      });

      var galleryMain = this.querySelector('[data-gallery-main]');
      if (galleryMain && this.lightbox) {
        galleryMain.addEventListener('click', () => {
          this.lightbox.hidden = false;
        });
      }

      if (galleryMain && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        galleryMain.addEventListener('mousemove', (event) => {
          var activeItem = galleryMain.querySelector('.product-merch__main-item.is-active');
          if (!activeItem) return;
          var layer = activeItem.querySelector('.product-merch__zoom-layer');
          if (!layer) return;
          if (layer.dataset.zoomSrc && !layer.style.backgroundImage) {
            layer.style.backgroundImage = 'url(' + layer.dataset.zoomSrc + ')';
          }
          var rect = galleryMain.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          layer.style.backgroundPosition = x + '% ' + y + '%';
          activeItem.classList.add('is-zooming');
        });
        galleryMain.addEventListener('mouseleave', () => {
          this.galleryMainItems.forEach(function (item) {
            item.classList.remove('is-zooming');
          });
        });
      }

      var lightboxItemEls = Array.from(this.querySelectorAll('[data-lightbox] .product-merch__lightbox-item'));
      var resetLightboxZoom = function () {
        lightboxItemEls.forEach(function (i) { i.classList.remove('is-zoomed'); });
      };

      var lightboxClose = this.querySelector('[data-lightbox-close]');
      if (lightboxClose && this.lightbox) {
        lightboxClose.addEventListener('click', () => {
          this.lightbox.hidden = true;
          resetLightboxZoom();
        });
      }
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (event) => {
          if (!event.target.closest('.product-merch__lightbox-image')) {
            this.lightbox.hidden = true;
            resetLightboxZoom();
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.lightbox.hidden = true;
            resetLightboxZoom();
          }
        });

        var lightboxImages = Array.from(this.querySelectorAll('[data-lightbox] .product-merch__lightbox-image'));
        lightboxImages.forEach((img) => {
          img.addEventListener('click', (event) => {
            event.stopPropagation();
            var item = img.closest('.product-merch__lightbox-item');
            var wasZoomed = item.classList.contains('is-zoomed');
            lightboxItemEls.forEach(function (i) { i.classList.remove('is-zoomed'); });
            if (!wasZoomed) {
              var rect = img.getBoundingClientRect();
              var originX = ((event.clientX - rect.left) / rect.width) * 100;
              var originY = ((event.clientY - rect.top) / rect.height) * 100;
              img.style.transformOrigin = originX + '% ' + originY + '%';
              item.classList.add('is-zoomed');
            }
          });
        });
      }

      this.updateAvailability();
      this.syncUI();
      this.updateVariant();
    }

    updateAvailability() {
      var self = this;
      this.optionGroups.forEach(function (group, index) {
        var pills = Array.from(group.querySelectorAll('[data-option-value]'));
        pills.forEach(function (pill) {
          var value = pill.getAttribute('data-option-value');
          var testSelection = self.selected.slice(0, index);
          testSelection[index] = value;
          var matches = self.variants.some(function (v) {
            var variantOpts = [v.option1, v.option2, v.option3];
            return testSelection.every(function (sel, i) { return sel == null || variantOpts[i] === sel; });
          });
          pill.hidden = !matches;
        });

        var currentValue = self.selected[index];
        var currentPill = pills.find(function (p) { return p.getAttribute('data-option-value') === currentValue; });
        if (!currentPill || currentPill.hidden) {
          var firstAvailablePill = pills.find(function (p) { return !p.hidden; });
          if (firstAvailablePill) {
            self.selected[index] = firstAvailablePill.getAttribute('data-option-value');
          }
        }
      });
    }

    syncUI() {
      var self = this;
      this.optionGroups.forEach(function (group, index) {
        var pills = Array.from(group.querySelectorAll('[data-option-value]'));
        pills.forEach(function (pill) {
          pill.classList.toggle('is-active', pill.getAttribute('data-option-value') === self.selected[index]);
        });
      });
    }

    updateVariant() {
      var self = this;
      var match = this.variants.find(function (v) {
        var variantOpts = [v.option1, v.option2, v.option3];
        return self.selected.every(function (sel, i) { return variantOpts[i] === sel; });
      });
      if (!match) return;

      if (this.variantIdInput) this.variantIdInput.value = match.id;
      if (this.priceEl) this.priceEl.textContent = match.price_formatted;
      if (this.addButton) {
        this.addButton.disabled = !match.available;
        this.addButton.textContent = match.available
          ? this.addButton.getAttribute('data-label-available')
          : this.addButton.getAttribute('data-label-sold-out');
      }
      if (this.buyNow) this.buyNow.hidden = !match.available;
      this.filterGalleryForVariant(match.id);
    }

    filterGalleryForVariant(variantId) {
      var idStr = String(variantId);

      function variantIdsOf(el) {
        var raw = el.getAttribute('data-variant-ids') || '';
        return raw ? raw.split(',') : [];
      }

      var dedicated = this.galleryMainItems.filter(function (el) {
        return variantIdsOf(el).indexOf(idStr) !== -1;
      });
      var pool = dedicated.length > 0
        ? dedicated
        : this.galleryMainItems.filter(function (el) { return variantIdsOf(el).length === 0; });
      var visibleIds = pool.map(function (el) { return el.getAttribute('data-media-id'); });

      function applyVisibility(elements) {
        var visible = [];
        elements.forEach(function (el) {
          var isVisible = visibleIds.indexOf(el.getAttribute('data-media-id')) !== -1;
          el.hidden = !isVisible;
          if (isVisible) visible.push(el);
        });
        return visible;
      }

      var visibleMain = applyVisibility(this.galleryMainItems);
      applyVisibility(this.galleryThumbs);
      applyVisibility(this.lightboxItems);

      if (this.thumbsWrap) {
        this.thumbsWrap.hidden = visibleMain.length <= 1;
      }

      var stillActive = visibleMain.find(function (el) { return el.classList.contains('is-active'); });
      var nextActive = stillActive || visibleMain[0];
      if (nextActive) this.setActiveMedia(nextActive.getAttribute('data-media-id'));
    }

    setActiveMedia(mediaId) {
      var idString = String(mediaId);
      this.galleryMainItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === idString);
      });
      this.galleryThumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === idString);
      });
      this.lightboxItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === idString);
      });
    }
  }

  customElements.define('product-merch', ProductMerch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios"] && !Shopify.designMode) return;
  try {
    
  class TestimoniosSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-testimonios-track]');
      var prev = this.querySelector('[data-testimonios-prev]');
      var next = this.querySelector('[data-testimonios-next]');
      if (!this.track) return;
      var step = () => {
        var card = this.track.querySelector('.testimonios__card');
        return card ? card.getBoundingClientRect().width + 16 : 320;
      };
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
    }
  }
  if (!customElements.get('testimonios-slider')) customElements.define('testimonios-slider', TestimoniosSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    

  class TimelineSection extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-timeline-list]');
      this.fill = this.querySelector('[data-timeline-fill]');
      if (!this.list || !this.fill) return;

      this.ticking = false;
      this.update = this.update.bind(this);
      this.requestUpdate = this.requestUpdate.bind(this);

      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate);
      this.update();
    }

    requestUpdate() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      var rect = this.list.getBoundingClientRect();
      var total = rect.height || 1;

      var sweepLine = window.innerHeight * 0.6;
      var progress = (sweepLine - rect.top) / total;
      progress = Math.max(0, Math.min(1, progress));
      this.fill.style.transform = 'scaleY(' + progress + ')';
    }
  }

  customElements.define('timeline-section', TimelineSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    

  class SectionVideoPlayer extends HTMLElement {
    connectedCallback() {
      var video = this.querySelector('video');
      var toggle = this.querySelector('[data-video-mute-toggle]');
      if (!video || !toggle) return;

      toggle.addEventListener('click', function () {
        video.muted = !video.muted;
        toggle.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        toggle.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
      });
    }
  }

  customElements.define('section-video-player', SectionVideoPlayer);

  } catch(e) { console.error(e); }
})();
})();
